var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.handleFullScreen}},[_c('GmapMap',{ref:"mapRef",style:({
      width: _vm.mapWidth + ' !important',
      height: _vm.mapHeight + ' !important',
    }),attrs:{"center":_vm.center,"options":_vm.options,"zoom":_vm.zoom}},[_c('GmapMarker',{attrs:{"clickable":false,"draggable":false,"position":_vm.markerLocation,"icon":_vm.icon}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }